import { useFormContext } from 'react-hook-form';
import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import WSTextField, { CurrencyType, TextType } from '../../../Components/TextBox/WSTextBox';


export const Step5Payroll = () => {
  const { register,formState:{errors},control } = useFormContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="CTC" type="number" fullWidth {...register('ctc')}/> */}
        <WSTextField id="weeklyOffDays" type={TextType.Currency} currency={CurrencyType.Rupee} label={"CTC"} control={control} name='ctc' />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!errors.paymentMode}>
    <InputLabel>Payment Mode</InputLabel>
    <Select
      label="Payment Mode"
      defaultValue=""
      {...register('paymentMode')}
    >
      <MenuItem value="Cash">Cash</MenuItem>
      <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
      <MenuItem value="Cheque">Cheque</MenuItem>
    </Select>
    {errors.paymentMode && (
      <p style={{ color: 'red', marginTop: 5 }}>
        {errors?.paymentMode?.message as string}
      </p>
    )}
  </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Bank Name" fullWidth {...register('bankDetails.bankName')} error={!!errors?.bankDetails}
          helperText={errors?.bankDetails?.message as string}/> */}
          <WSTextField id="bankDetails.bankName" label={"Bank Name"} control={control} name='bankDetails.bankName' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Account Number" fullWidth {...register('bankDetails.accountNumber')} 
        error={!!errors?.bankDetails}
          helperText={errors?.bankDetails?.message as string}/> */}
          <WSTextField id="bankDetails.accountNumber" label={"Account Number"} control={control} name='bankDetails.accountNumber' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="IFSC Code" fullWidth {...register('bankDetails.ifsc')} error={!!errors?.bankDetails}
          helperText={errors?.bankDetails?.message as string}/> */}
          <WSTextField id="bankDetails.ifsc" label={"IFSC Code"} control={control} name='bankDetails.ifsc' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="PAN Number" fullWidth {...register('pan')} /> */}
        <WSTextField id="pan" label={"PAN Number"} control={control} name='pan' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Aadhaar Number" fullWidth {...register('aadhaar')} /> */}
        <WSTextField id="aadhaar" label={"Aadhaar Number"} control={control} name='aadhaar' />
      </Grid>
    </Grid>
  );
};
